// Copyright (c) billwerk GmbH. All rights reserved.
"use strict";

var BulkUpgradeContractsController = function ($scope, $http, $location, BulkUpdateContractsFilterBag, gettext,
    BulkUpdatesNavigationHelper, DocumentTemplate, ProductInfo, babelFilter, Component, EmailNotificationsTemplatesByEventCategory, Features) {
    $scope.allOption = 'All';
    $scope.selectOption = 'Select';
    
    /* Translations */
    $scope.previewTabHeading = gettext('Create preview');
    $scope.executeTabHeading = gettext('Execute');
    $scope.previewExecuteButtonTooltip_OperationInProgress = gettext('Only one bulk update operation can be in progress at the same time');
    $scope.previewButtonTooltip_PlanGroupFilterRequired = gettext('Please choose a plan group to create a preview');
    $scope.previewButtonTooltip_SettingsNotSelected = gettext('Please select at least one setting to upgrade to create a preview');
    $scope.previewButtonTooltip_EndDateRequired = gettext('Please choose a contract change date to create a preview');
    $scope.previewButtonTooltip_FileFilterRequired = gettext('Please choose a file to create a preview');
    $scope.currencyTooltip = gettext('Please select Currency in the filter section if you would like to update the Price List');
    $scope.priceListTooltip = gettext('Price list change do not influence on Billing Precision for contract');

    /* Filter & Preview */
    $scope.flagToSwitchToExecuteTab = true;
    $scope.ResetFileFlag = false;


    // Creating this object because of https://www.youtube.com/watch?v=DTx23w4z6Kc&ab_channel=JohnLindquist
    // (or https://github.com/angular/angular.js/wiki/Understanding-Scopes)
    // Otherwise e.g. isPreviewDisabled() couldn't get a fresh BookingDate value; since booking date
    // datepicker is placed inside the tab set, it's being accessed inside the child scope
    $scope.scopeHolder = {
        Filter: BulkUpdateContractsFilterBag.filter ? BulkUpdateContractsFilterBag.filter : emptyFilter(),
        Parameters: clearParamenters(),
        ShowOutdatedPreviews: false,
        Tab: "preview",
        IsLoading: false,
        IsAnyOperationInProgress: false,
    };
    
    $scope.newComponentSubscription = {};
    $scope.newDiscount = {};
    $scope.newMeteredUsage = {};
    $scope.newRatedItem = {};
    $scope.componentService = Component;

    // allows to refresh the list of bulk operation from the controller 
    $scope.refreshHandler = { refresh: null };

    $scope.features = Features.features;
    function refreshBulkOperations() {
        if ($scope.refreshHandler.refresh)
            $scope.refreshHandler.refresh();
    }

    // navigate to execution tab when the page is opened and some operation is in progress
    $scope.$watch("scopeHolder.IsAnyOperationInProgress", function(hasOperationsInProgress) {
        if ($scope.flagToSwitchToExecuteTab && hasOperationsInProgress) {
            $scope.flagToSwitchToExecuteTab = false;
            $scope.scopeHolder.Tab = "execute";
        }
    });
    
    $scope.parametersChanged = function () {
        $scope.scopeHolder.Parameters.PlanVariantId = null;
    }

    $scope.isCurrencySameFilter = function (priceList) {
        return priceList.Currency === $scope.scopeHolder.Filter.Currency;
    }

    $scope.$watch("scopeHolder.Parameters.PlanId", function (planId) {

        if (!planId)
            $scope.showRequiresOrderApprovalCheckbox = false;

        if ($scope.productInfo.Plans){
            let chosenPlan = $scope.productInfo.Plans.find(function (plan) {
                return plan.Id === planId
            });
            if (chosenPlan)
                $scope.showRequiresOrderApprovalCheckbox = chosenPlan.RequiresOrderApproval
        }        
    });
    
    $scope.filterChanged = function (source) {
        switch (source) {
            case "planGroup":
                $scope.scopeHolder.Filter.PlanId = null;
                $scope.scopeHolder.Filter.PlanVariantId = null;

                $scope.scopeHolder.Parameters.PlanId = null;
                $scope.scopeHolder.Parameters.PlanVariantId = null;
                $scope.scopeHolder.Parameters.IgnoreApprovalPending = false;
                
                $scope.scopeHolder.Parameters.ComponentSubscriptions = [];
                $scope.scopeHolder.Parameters.MeteredUsages = [];
                $scope.scopeHolder.Parameters.Discounts = [];
                $scope.scopeHolder.Parameters.RatedItems = [];

                $scope.clearNewComponentSubscription();
                $scope.clearNewDiscount();
                $scope.clearNewMeteredUsage();
                $scope.clearNewRatedItem();
                
                break;
            case "plan":
                $scope.scopeHolder.Filter.PlanVariantId = null;
                break;
            default:
                break;
        }
    }

    getContractStatuses();

    $scope.productInfo = ProductInfo.get(function (data) {
        $scope.uniqueCurrencies = [...new Set(data.PriceLists.map(item => item.Currency))];
    });
    
    /* scope functions */
    $scope.filterByIdChanged = function () {
        $scope.filterByIds = $scope.scopeHolder.Filter.FilterByIdType !== 'None';
        if ($scope.filterByIds) {
            $scope.scopeHolder.Filter.StartDateFrom = "";
            $scope.scopeHolder.Filter.StartDateTo = "";
            $scope.scopeHolder.Filter.Status = "";
            $scope.scopeHolder.Filter.ExcludeContractsWithEndDate = false;
        }
    }

    $scope.saveFile = function ($files) {
        $scope.scopeHolder.Filter.File = $files[0];
        if ($scope.scopeHolder.Filter.File)
            $scope.isFileSelected = true;
        else
            $scope.isFileSelected = false;
        $scope.$apply();
    };

    $scope.isPreviewDisabled = function () {
        return !!$scope.getValidationError();
    };

    $scope.getValidationError = function () {
        // file is required when id type is selected
        if ($scope.scopeHolder.Filter.FilterByIdType !== 'None') {
            if (!$scope.scopeHolder.Filter.File)
                return $scope.previewButtonTooltip_FileFilterRequired;
        }
        // status filter is required
        if (!$scope.scopeHolder.Filter.PlanGroupId)
            return $scope.previewButtonTooltip_PlanGroupFilterRequired;
        // at least one setting should be applied
        else if (!anySettingSelectedForUpgrade())
            return $scope.previewButtonTooltip_SettingsNotSelected;
        // end date is required
        else if (!$scope.scopeHolder.Parameters.ChangeDate && !$scope.scopeHolder.Parameters.PresetChangeDate)
            return $scope.previewButtonTooltip_EndDateRequired;
        // there should be no running operation
        else if ($scope.scopeHolder.IsAnyOperationInProgress)
            return $scope.previewExecuteButtonTooltip_OperationInProgress;

        return null;
    };

    $scope.createPreview = function () {
        var formData = new FormData();

        formData.append("Type", "1");
        const filterName = "Filter";
        const upgradeContractsFilterName = `${filterName}.UpgradeContracts`;
        formData.append("Filter.IdType", $scope.scopeHolder.Filter.FilterByIdType);

        if ($scope.filterByIds) {
            formData.append("Filter.IdsFile", $scope.scopeHolder.Filter.File);
        }
        else {
            formData.append(`${upgradeContractsFilterName}.Status`, getFilterStatus($scope.scopeHolder.Filter.Status));
            if ($scope.scopeHolder.Filter.StartDateFrom)
                formData.append(`${upgradeContractsFilterName}.StartDateFrom`, moment($scope.scopeHolder.Filter.StartDateFrom).format());
            if ($scope.scopeHolder.Filter.StartDateTo)
                formData.append(`${upgradeContractsFilterName}.StartDateTo`, moment($scope.scopeHolder.Filter.StartDateTo).format());
            if ($scope.scopeHolder.Filter.PlanId)
                formData.append(`${upgradeContractsFilterName}.PlanId`, $scope.scopeHolder.Filter.PlanId);
            if ($scope.scopeHolder.Filter.PlanVariantId)
                formData.append(`${upgradeContractsFilterName}.PlanVariantId`, $scope.scopeHolder.Filter.PlanVariantId);
            if ($scope.scopeHolder.Filter.Currency)
                formData.append(`${upgradeContractsFilterName}.Currency`, $scope.scopeHolder.Filter.Currency);
            if ($scope.scopeHolder.Filter.ExcludeContractsWithEndDate)
                formData.append(`${upgradeContractsFilterName}.ExcludeContractsWithEndDate`, $scope.scopeHolder.Filter.ExcludeContractsWithEndDate);
        }

        formData.append(`${upgradeContractsFilterName}.PlanGroupId`, $scope.scopeHolder.Filter.PlanGroupId);
        
        const parametersName = "Parameters";
        const upgradeContractsParametersName = `${parametersName}.UpgradeContracts`;
        let formattedBookingDate = moment($scope.scopeHolder.Parameters.ChangeDate).format();
        formData.append(`${upgradeContractsParametersName}.ChangeDate`, formattedBookingDate);
        formData.append(`${upgradeContractsParametersName}.PresetChangeDate`, $scope.scopeHolder.Parameters.PresetChangeDate === '' ? null : $scope.scopeHolder.Parameters.PresetChangeDate);
        if($scope.scopeHolder.Parameters.PlanVariantId)
            formData.append(`${upgradeContractsParametersName}.PlanVariantId`, $scope.scopeHolder.Parameters.PlanVariantId);
        if($scope.scopeHolder.Parameters.PriceListId)
            formData.append(`${upgradeContractsParametersName}.PriceListId`, $scope.scopeHolder.Parameters.PriceListId);
        formData.append(`${upgradeContractsParametersName}.BypassContractsWithPlannedChange`, $scope.scopeHolder.Parameters.BypassContractsWithPlannedChange);
        if ($scope.scopeHolder.Parameters.EmailTemplateExternalId)
            formData.append(`${upgradeContractsParametersName}.EmailTemplateExternalId`, $scope.scopeHolder.Parameters.EmailTemplateExternalId);
        else
            formData.append(`${upgradeContractsParametersName}.EmailTemplateExternalId`, 'None');
        const componentSubscriptionsName = `${upgradeContractsParametersName}.ComponentSubscriptions`;
        if ($scope.scopeHolder.Parameters.ComponentSubscriptions) {
            for (let i = 0; i < $scope.scopeHolder.Parameters.ComponentSubscriptions.length; i++) {
                const sub = $scope.scopeHolder.Parameters.ComponentSubscriptions[i];

                formData.append(`${componentSubscriptionsName}[${i}].ComponentId`, sub.ComponentId);
                formData.append(`${componentSubscriptionsName}[${i}].Quantity`, sub.Quantity);
                if (sub.Memo)
                    formData.append(`${componentSubscriptionsName}[${i}].Memo`, sub.Memo);
                if (sub.ProductOverride) {
                    if (sub.ProductOverride.Name)
                        formData.append(`${componentSubscriptionsName}[${i}].ProductOverride.Name`, sub.ProductOverride.Name);
                    if (sub.ProductOverride.Description)
                        formData.append(`${componentSubscriptionsName}[${i}].ProductOverride.Description`, sub.ProductOverride.Description);
                    if (sub.ProductOverride.PricePerUnit)
                        formData.append(`${componentSubscriptionsName}[${i}].ProductOverride.PricePerUnit`, sub.ProductOverride.PricePerUnit);
                }
            }
        }

        if($scope.scopeHolder.Parameters.Discounts) {
            for (let i = 0; i < $scope.scopeHolder.Parameters.Discounts.length; i++) {
                const disc = $scope.scopeHolder.Parameters.Discounts[i];

                formData.append(`${upgradeContractsParametersName}.Discounts[${i}].DiscountId`, disc.DiscountId);
            }
        }

        const meteredUsagesName = `${upgradeContractsParametersName}.MeteredUsages`;
        if ($scope.scopeHolder.Parameters.MeteredUsages) {
            for (let i = 0; i < $scope.scopeHolder.Parameters.MeteredUsages.length; i++) {
                const sub = $scope.scopeHolder.Parameters.MeteredUsages[i];

                formData.append(`${meteredUsagesName}[${i}].ComponentId`, sub.ComponentId);
                formData.append(`${meteredUsagesName}[${i}].Quantity`, sub.Quantity);
                if (sub.Memo)
                    formData.append(`${meteredUsagesName}[${i}].Memo`, sub.Memo);
                if (sub.ProductOverride) {
                    if (sub.ProductOverride.Name)
                        formData.append(`${meteredUsagesName}[${i}].ProductOverride.Name`, sub.ProductOverride.Name);
                    if (sub.ProductOverride.Description)
                        formData.append(`${meteredUsagesName}[${i}].ProductOverride.Description`, sub.ProductOverride.Description);
                    if (sub.ProductOverride.PricePerUnit)
                        formData.append(`${meteredUsagesName}[${i}].ProductOverride.PricePerUnit`, sub.ProductOverride.PricePerUnit);
                }
            }
        }

        const ratedItemsName = `${upgradeContractsParametersName}.RatedItems`;
        if ($scope.scopeHolder.Parameters.RatedItems) {
            for (let i = 0; i < $scope.scopeHolder.Parameters.RatedItems.length; i++) {
                const sub = $scope.scopeHolder.Parameters.RatedItems[i];

                formData.append(`${ratedItemsName}[${i}].Description`, sub.Description);
                formData.append(`${ratedItemsName}[${i}].Quantity`, sub.Quantity);
                formData.append(`${ratedItemsName}[${i}].PricePerUnit`, sub.PricePerUnit);
                formData.append(`${ratedItemsName}[${i}].TaxPolicyId`, sub.TaxPolicyId);
            }
        }

        if ($scope.scopeHolder.Parameters.IgnoreApprovalPending) {
            formData.append(`${upgradeContractsParametersName}.IgnoreApprovalPending`, $scope.scopeHolder.Parameters.IgnoreApprovalPending);
        }

        $http({
            method: "POST",
            url: "/api/v1/bulkoperation/preview",
            data: formData,
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        }).then(
            function () {
                refreshBulkOperations();
                $scope.scopeHolder.Tab = "execute";
                
                $scope.scopeHolder.Filter = emptyFilter();
                $scope.scopeHolder.Parameters = clearParamenters();
                resetUploadedFile();
            }
        );
    };

    $scope.isExecutionDisabled = function () {
        return $scope.scopeHolder.IsAnyOperationInProgress;
    }

    $scope.execute = function (bulkUpdateId) {
        $http({
            method: "POST",
            url: "/api/v1/bulkOperation/" + bulkUpdateId + "/execute",
        }).then(
            function () {
                refreshBulkOperations();
                $scope.scopeHolder.Tab = "execute";
            }
        );
    }

    EmailNotificationsTemplatesByEventCategory.query({ category: 'OrderSucceeded'}).$promise.then(function (response) {
        $scope.scopeHolder.emailTemplates = response;
        response.every(function (item){
                if(item.DefaultForSubEvents)
                    return item.DefaultForSubEvents.every(function (subEvents){
                        if(subEvents==="UpDowngrade"){
                            $scope.scopeHolder.Parameters.EmailTemplateExternalId=item.ExternalId;
                            return false;
                        }
                        return true;
                    });
                return true;
            }
        );
    });
    
    // recurring components
    $scope.addComponentSubscription = function () {
        if ($scope.newComponentSubscription.ComponentId) {
            let newComponentSubscriptionCopy = JSON.parse(angular.toJson($scope.newComponentSubscription));
            $scope.scopeHolder.Parameters.ComponentSubscriptions.push(newComponentSubscriptionCopy);

            $scope.clearNewComponentSubscription();
        }
    };
    $scope.isNonMetered = function (item) {
        return item.ComponentType !== 'Metered' && item.PlanGroupId === $scope.scopeHolder.Filter.PlanGroupId;
    };

    $scope.deleteComponent = function (hashKey) {
        $scope.scopeHolder.Parameters.ComponentSubscriptions = $scope.scopeHolder.Parameters.ComponentSubscriptions.filter(
            function (item) { return item.$$hashKey !== hashKey; });
    };
    $scope.clearNewComponentSubscription = function () {
        $scope.newComponentSubscription = {
            Quantity: 1,
            IsNewComponent: true,
            ProductOverride: null,
        };
    };    

    // Discounts management
    {
        $scope.addDiscountSubscription = function () {
            if ($scope.newDiscount && $scope.newDiscount.DiscountId) {
                let newDiscountCopy = JSON.parse(angular.toJson($scope.newDiscount));
                $scope.scopeHolder.Parameters.Discounts.push(newDiscountCopy);

                $scope.clearNewDiscount();
            }
        };
        $scope.deleteDiscountSubscription = function (hashKey) {
            $scope.scopeHolder.Parameters.Discounts = $scope.scopeHolder.Parameters.Discounts.filter(
                function (item) { return item.$$hashKey !== hashKey; });
        };
        $scope.clearNewDiscount = function () {
            $scope.newDiscount = { IsNewDiscount: true };
        }
    }

    // metered usages
    $scope.isMetered = function (item) {
        return item.ComponentType === 'Metered' && item.PlanGroupId === $scope.scopeHolder.Filter.PlanGroupId;
    };

    $scope.isPriceDefinedForComponent = function (item) {
        let isDefined = false;

        if (!$scope.scopeHolder.Parameters.PriceListId) {
            return true;
        }

        $scope.productInfo.PriceLists.forEach(function (priceList) {
            if (priceList.Id === $scope.scopeHolder.Parameters.PriceListId) {
                if (priceList.Items.filter(x => x.ProductId === item.Id).length > 0 
                    || priceList.ParentItems.filter(x => x.ProductId === item.Id).length > 0) {
                    isDefined = true;
                }
            }
        });
        
        return isDefined;
    };
    
    $scope.addMeteredUsage = function () {
        if ($scope.newMeteredUsage.ComponentId) {
            let newMeteredUsageCopy = JSON.parse(angular.toJson($scope.newMeteredUsage));
            if (!newMeteredUsageCopy.Quantity) newMeteredUsageCopy.Quantity = 1;
            $scope.scopeHolder.Parameters.MeteredUsages.push(newMeteredUsageCopy);

            $scope.clearNewMeteredUsage();
        }
    };

    $scope.getPriceForComponent = function (item, isMetered) {
        let price;

        if (isMetered)
            price = $scope.productInfo.getMeteredComponentPrice(item, $scope.scopeHolder.Parameters.PriceListId);
        else
            price = $scope.productInfo.getRecurringComponentPrice(item, $scope.scopeHolder.Parameters.PriceListId);

        return price === 'No price' ? 'Defined in price list' : price;
    };
    
    $scope.deleteNewMeteredUsage = function (hashKey) {
        $scope.scopeHolder.Parameters.MeteredUsages = $scope.scopeHolder.Parameters.MeteredUsages.filter(
            function (item) { return item.$$hashKey !== hashKey; });
    };
    $scope.clearNewMeteredUsage = function () {
        $scope.newMeteredUsage = {
            Quantity: 1,
            IsNewMeteredUsage: true,
            ProductOverride: {},
        };
    };
    
    // override 
    $scope.ResetComponentSubscriptionProductOverride = function () {
        $scope.newComponentSubscription.ProductOverride = null;
    };
    $scope.ResetMeteredUsageProductOverride = function () {
        $scope.newMeteredUsage.ProductOverride = null;
    };
    $scope.GetComponentName = function (baseComponent, newComponent) {
        const isOverrideNameExist = baseComponent.Id &&
            newComponent &&
            baseComponent.Id === newComponent.ComponentId &&
            newComponent.ProductOverride &&
            newComponent.ProductOverride.Name &&
            newComponent.ProductOverride.Name !== "";

        if (isOverrideNameExist) {
            return `${baseComponent.ExternalId} ${newComponent.ProductOverride.Name} - ${babelFilter(baseComponent.Name)}`
        }
        
        const externalIdString = baseComponent.ExternalId ? `${baseComponent.ExternalId} ` : ''; 
        return `${externalIdString}${babelFilter(baseComponent.Name)}`
    };

    // Rated items    
    $scope.addRatedItem = function () {
        if ($scope.newRatedItem.Quantity && $scope.newRatedItem.TaxPolicyId &&
            $scope.newRatedItem.PricePerUnit && $scope.newRatedItem.Description) {
            let newRatedItemCopy = JSON.parse(angular.toJson($scope.newRatedItem));
            if (!newRatedItemCopy.Quantity) newRatedItemCopy.Quantity = 1;
            $scope.scopeHolder.Parameters.RatedItems.push(newRatedItemCopy);

            $scope.clearNewRatedItem();
        }
    };
    $scope.deleteNewRatedItem = function (hashKey) {
        $scope.scopeHolder.Parameters.RatedItems = $scope.scopeHolder.Parameters.RatedItems.filter(
            function (item) { return item.$$hashKey !== hashKey; });
    };
    $scope.deleteExistingRatedItem = function (index) {
        $scope.scopeHolder.Parameters.RatedItems[index].IsDeletedNow = true;
    };
    $scope.clearNewRatedItem = function () {
        $scope.newRatedItem = { Quantity: 1, PricePerUnit: "", IsNewRatedItem: true };
    }
    
    /* functions */
    function anySettingSelectedForUpgrade() {
        return $scope.scopeHolder.Parameters.PlanVariantId ||               // a new plan variant is selected
            ($scope.scopeHolder.Parameters.ComponentSubscriptions || []).length > 0 || // any recurring component is added
            ($scope.scopeHolder.Parameters.MeteredUsages || []).length > 0 ||          // any metered component is added
            ($scope.scopeHolder.Parameters.Discounts || []).length > 0 ||              // any discount is added
            ($scope.scopeHolder.Parameters.RatedItems || []).length > 0;               // any rated item is added
    }

    function getContractStatuses() {
        $http({
            method: "GET",
            url: "/api/v1/bulkoperation/contractstatus"
        }).then(function (response) {
            $scope.scopeHolder.ContractStatuses = response.data;
        });
    }

    function getFilterStatus(status) {
        if (status === 'In Trial')
            return 'InTrial';

        return status;
    }

    function emptyFilter() {
        return {
            Action: "Up-/Downgrade contracts",
            StartDateFrom: null,
            StartDateTo: null,
            Status: "All",
            PlanGroupId: null,
            PlanId: null,
            PlanVariantId: null,
            FilterByIdType: "None",
            File: null,
            ExcludeContractsWithEndDate: false
        };
    }
    function clearParamenters() {
        return {
            ChangeDate: null,
            PresetChangeDate: null,
            BypassContractsWithPlannedChange: false,
            ComponentSubscriptions: [],
            Discounts: [],
            MeteredUsages: [],
            RatedItems: [],
        }
    }

    var resetUploadedFile = function () {
        $scope.ResetFileFlag = !$scope.ResetFileFlag;
    };

    $scope.clearNewComponentSubscription();
    $scope.clearNewDiscount();
    $scope.clearNewMeteredUsage();
    $scope.clearNewRatedItem();
};

BulkUpgradeContractsController.$inject = ["$scope", "$http", "$location", "BulkUpdateContractsFilterBag", "gettext",
    "BulkUpdatesNavigationHelper", "DocumentTemplate", "ProductInfo", "babelFilter", "Component", "EmailNotificationsTemplatesByEventCategory", "Features"];
